import { useCallback } from 'react';
import { Outlet, NavLink, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { AppShell } from '@semsis/ui/AppShell';
import { Select } from '@semsis/ui/Select';
import { ShellBar } from '@semsis/ui/ShellBar';
import { SideNav, SideNavItem } from '@semsis/ui/SideNav';
import { trackEvent } from '@referee/analytics';
import { faClipboardList, faChartPie, faCircleInfo, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { useBackButton } from '../utils/useBackButton';
import styles from './PracticeLayout.module.css';

const languageOptions = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'Deutsch' },
  { value: 'es', label: 'Español' },
  { value: 'pt', label: 'Português' },
  { value: 'fr', label: 'Français' },
  { value: 'pl', label: 'Polski' },
  { value: 'me', label: 'Crnogorski' },
  { value: 'sq', label: 'Shqip' },
];

export function PracticeLayout() {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  useBackButton();

  const handleLanguageChange = useCallback((lng: string) => {
    trackEvent('language_changed', { from_language: i18n.language.substring(0, 2), to_language: lng });
    i18n.changeLanguage(lng);
  }, [i18n]);

  return (
    <AppShell
      shellBar={
        <ShellBar logo={<img src={`${import.meta.env.BASE_URL}logo.svg`} alt="Referee" />} title="referee.app">
          <div className={styles['language-selector']}>
            <Select
              options={languageOptions}
              value={i18n.language.substring(0, 2)}
              variant="shell"
              onValueChange={handleLanguageChange}
            />
          </div>
        </ShellBar>
      }
      sideNav={
        <SideNav>
          <SideNavItem asChild icon={faClipboardList} label={t('menu.test')} active={pathname === '/'}>
            <NavLink to="/" end />
          </SideNavItem>
          <SideNavItem asChild icon={faGraduationCap} label={t('menu.testMode')} active={pathname.startsWith('/test')}>
            <NavLink to="/test" />
          </SideNavItem>
          <SideNavItem asChild icon={faChartPie} label={t('menu.stats')} active={pathname === '/stats'}>
            <NavLink to="/stats" />
          </SideNavItem>
          <SideNavItem asChild icon={faCircleInfo} label={t('menu.about')} active={pathname === '/about'}>
            <NavLink to="/about" />
          </SideNavItem>
        </SideNav>
      }
    >
      <Outlet />
    </AppShell>
  );
}
